import { render, staticRenderFns } from "./SpringPage.vue?vue&type=template&id=d06d23a0&scoped=true&"
import script from "./SpringPage.vue?vue&type=script&lang=js&"
export * from "./SpringPage.vue?vue&type=script&lang=js&"
import style0 from "./SpringPage.vue?vue&type=style&index=0&id=d06d23a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06d23a0",
  null
  
)

export default component.exports